module.exports = __webpack_public_path__ + "img/kloppenheim_04_2k.2716e0f0.png";